import { Component, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-admin-ml-page-guide',
  standalone: false,
  templateUrl: './admin-ml-page-guide.html',
  styleUrl: './admin-ml-page-guide.css'
})
export class AdminMlPageGuide {
  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  @Input() purpose = '';
  @Input() steps: string[] = [];
  @Input() important = '';
  @Input() accessNote = '';
  @Input() defaultOpen = true;

  scrollToGuide(): void {
    const guideElement = this.elementRef.nativeElement;
    const detailsElement = guideElement.querySelector('details');

    if (detailsElement) {
      detailsElement.open = true;
    }

    guideElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
    guideElement.focus({ preventScroll: true });
  }
}
